<p-toast key="rejected-bulk-orders-dialog"></p-toast>
<div
  class="align-content-center flex-wrap ml-4 mr-4 mt-4 shadow-3 surface-card"
>
  <div class="flex align-items-center justify-content-center">
    <h2 class="p-2 mt-0 mb-2 text-900 font-bold text-4xl">Bulk Order Items</h2>
  </div>
</div>
<div
  class="overflow-x-scroll px-4 py-2 md:px-6 lg:px-8"
  style="margin-top: 50px"
>
  <p-table
    #dt
    [value]="order_types"
    dataKey="type_name"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <button
            pButton
            pRipple
            label="Add Order Type"
            icon="pi pi-plus"
            class="w-auto p-button-sm p-button-outlined p-button-primary"
            (click)="showOrderTypeDialog()"
        ></button>
      </div>
      </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <!-- Expand icon column -->
        <th *ngFor="let col of orderTypeColumns">{{ col.header }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-expanded="expanded">
      <tr>
        <td>
          <a href="#" (click)="dt.toggleRow(rowData); $event.preventDefault()">
            <i
              class="pi"
              [ngClass]="{
                'pi-chevron-down': expanded,
                'pi-chevron-right': !expanded
              }"
            ></i>
          </a>
        </td>
        <td *ngFor="let col of orderTypeColumns">
          {{ rowData[col.field] }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-order>
      <tr>
        <td colspan="4">
          <div *ngIf="order.options?.length > 0; else noOptions">
            <ul>
              <li *ngFor="let opt of order.options">
                {{ opt.option_name }} ({{ opt.option_value }})
              </li>
            </ul>
          </div>
          <ng-template #noOptions>
            <span>No options available</span>
          </ng-template>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          [attr.colspan]="this.getNumberofColumns()"
          class="align-content-center"
        >
          <p-progressBar
            styleClass="align-self-center"
            *ngIf="isLoading"
            mode="indeterminate"
          >
          </p-progressBar>
          <div *ngIf="!isLoading">
            <p>
              There are no records to show. You might be disconnected or
              offline.
            </p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
